export const FETCH_AI_CHAT_HISTORY = 'FETCH_AI_CHAT_HISTORY';
export const FETCH_AI_CHAT_HISTORY_SUCCESS = 'FETCH_AI_CHAT_HISTORY_SUCCESS';
export const FETCH_AI_CHAT_HISTORY_ERROR = 'FETCH_AI_CHAT_HISTORY_ERROR';

export const FETCH_AI_CHAT_SEND_MSG = 'FETCH_AI_LATEST_CHAT';
export const FETCH_AI_CHAT_SEND_MSG_SUCCESS = 'FETCH_AI_CHAT_SEND_MSG_SUCCESS';
export const FETCH_AI_CHAT_SEND_MSG_ERROR = 'FETCH_AI_CHAT_SEND_MSG_ERROR';
